import * as React from 'react'

import { Box, Chevron, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  statsLength: number
  toogleExpand: React.Dispatch<React.SetStateAction<boolean>>
  isExpanded: boolean
}

const ToggleList = ({ statsLength, toogleExpand, isExpanded }: Props) => {
  const paddingTop = isExpanded ? null : 's16'
  const direction = isExpanded ? 'up' : 'down'

  const text = isExpanded
    ? i18n.t('time_off.overview.stats.show_less')
    : i18n.t('time_off.overview.stats.show_more', {
        count: statsLength,
      })

  return (
    <Box
      paddingX="s40"
      paddingY={paddingTop}
      cursor="pointer"
      onClick={() => toogleExpand(!isExpanded)}
      flexDirection="row"
      alignItems="center"
      gap="s8"
    >
      <Text size="300" weight="medium" color="viridian1200">
        {text}
      </Text>
      <Chevron type="brand" direction={direction} />
    </Box>
  )
}

export default ToggleList
